import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  getPurchasedItems,
  markAsDamaged,
} from "../../../redux/features/assetManagementSlice";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import {
  CancelButton,
  SubmitButton,
} from "../../../components/mui/Buttons/Buttons";

const MarkAsDamaged = ({notDelivered,row, dispatchParams }) => {
  const [open, setOpen] = useState(false);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((store) => store.assetmanagement);

  const initialValues = {
    damagedReason: "",
    isDamaged: true,
    count: 1,
  };

  const schema = Yup.object({
    count: Yup.number()
      .required("Count is required")
      .positive("Count must be greater than 0")
      .integer("Count must be an integer")
      .test(
        "max-count",
        `Count must be less than or equal to ${row?.quantity}`,
        function (value) {
          return value <= row?.quantity;
        }
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { ...values };
      if (row) {
        const updateData = { ...data, purchaseId: row.purchaseID };
        dispatch(markAsDamaged(updateData)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getPurchasedItems(dispatchParams));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });


  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Mark As Damaged"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            size="small"
            disabled={notDelivered||row?.isDamaged}
            variant="outlined"
            onClick={() => setOpen(true)}
          >
            Mark As Damaged
          </Button>
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box component={Paper} elevation={2} p={2} borderRadius={2}>
                <Stack direction={"row"} alignItems="center" spacing={1}>
                  <Icon
                    icon="game-icons:cracked-glass"
                    width="25"
                    height="25"
                    style={{ color: "#7e4d8b" }}
                  />
                  <Box>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="isDamaged"
                            checked={formik.values.isDamaged}
                            // onChange={formik.handleChange}
                            
                          />
                        }
                        label="Product Damaged"
                      />
                    </FormGroup>
                  </Box>
                </Stack>
                <Box my={1}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="count"
                    label="Count"
                    name="count"
                    value={formik.values.count}
                    onChange={formik.handleChange}
                    error={formik.touched.count && Boolean(formik.errors.count)}
                    helperText={formik.touched.count && formik.errors.count}
                  />
                </Box>

                <TextField
                  autoComplete="off"
                  fullWidth
                  id="damagedReason"
                  label="Damage Remarks"
                  name="damagedReason"
                  value={formik.values.damagedReason}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.damagedReason &&
                    Boolean(formik.errors.damagedReason)
                  }
                  helperText={
                    formik.touched.damagedReason && formik.errors.damagedReason
                  }
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <CancelButton action={() => handleCancel()}>
                    Cancel
                  </CancelButton>
                  <SubmitButton disabled={loading} type="submit">
                    {loading ? "Submiting..." : "Submit"}
                  </SubmitButton>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default MarkAsDamaged;
